import { Action, createReducer, on } from '@ngrx/store';
import {
    clearGuestPayment,
    clearGuestPaymentRequest,
    loadGuestPayment,
    loadGuestPaymentFailed,
    loadGuestPaymentSuccess,
    loadTransaction,
    loadTransactionSuccess
} from './payments.actions'; import { PaymentRequest, PaymentResponse, Transaction } from '@app/model/payments/payments.model';

export interface PaymentsState {
    guestPaymentRequest: PaymentRequest;
    guestPayment: PaymentResponse;
    guestPaymentError: string;
    transaction: Transaction;
}

const initialState: PaymentsState = {
    guestPaymentRequest: undefined,
    guestPayment: undefined,
    guestPaymentError: undefined,
    transaction: undefined
};

const paymentsReducer = createReducer(
    initialState,
    on(clearGuestPaymentRequest, (state) => ({ ...state, guestPaymentRequest: undefined })),
    on(loadGuestPayment, (state, { guestPaymentRequest }) => ({ ...state, guestPaymentRequest, guestPaymentError: undefined })),
    on(loadGuestPaymentSuccess, (state, { guestPayment }) => ({ ...state, guestPayment, guestPaymentError: undefined })),
    on(loadGuestPaymentFailed, (state, { guestPaymentError }) => ({ ...state, guestPaymentError })),
    on(clearGuestPayment, (state) => ({ ...state, guestPayment: undefined })),
    on(loadTransaction, (state) => ({ ...state, transaction: undefined })),
    on(loadTransactionSuccess, (state, { transaction }) => ({ ...state, transaction }))
);

export function reducer(state: PaymentsState | undefined, action: Action) {
    return paymentsReducer(state, action);
}

